import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  max-height: 80vh;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;
    
  .spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px;
  }

  section {
    flex: 1;
    overflow-y: auto;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;

    & h3 {
      margin-bottom: 30px;
      font-size: 20px;
    }
  }

  .row {
    position: relative;
    min-height: 50px;
    cursor: pointer;
    overflow-x: hidden;
    -webkit-flex: 0
    -ms-flex: 0;
    flex: 0;
    display: inline;

    & img.check {
      position: absolute;
      right: 0;
      width: 30px;
      height: 30px;
    }

    & li {
      border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      padding: 0 20px;
    }

    &:hover {
      background-color: #F3F3F3;
    }

    &:first-child {
      & li {
        border-top: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      }
    }
  }

  .saveButton {
    width: max-content;
    padding: 20px;
    margin-top: 20px;
    align-self: end;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }

  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
